/* ==========================================================================
   Penderyn Distillery — Shopify Theme JavaScript
   ========================================================================== */

(function () {
  'use strict';

  /* ---------- DOM Ready ---------- */
  function onReady(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  onReady(function () {
    syncAnnouncementHeight();
    initHeroVideo();
    initHeaderScroll();
    initMobileMenu();
    initCartDrawer();
    initDrawerQuantityControls();
    initCartPageQuantities();
    initDrawerGift();
    initAjaxAddToCart();
    initQuantitySelectors();
    initSmoothScroll();
    initProductGallery();
  });


  /* ---------- Header Scroll State ---------- */
  function initHeaderScroll() {
    var header = document.getElementById('site-header');
    if (!header) return;

    var scrollThreshold = 50;
    var ticking = false;

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          if (window.scrollY > scrollThreshold) {
            header.classList.add('site-header--scrolled');
          } else {
            header.classList.remove('site-header--scrolled');
          }
          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }


  /* ---------- Mobile Menu ---------- */
  function initMobileMenu() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var mobileNav = document.getElementById('mobile-nav');
    if (!toggle || !mobileNav) return;

    toggle.addEventListener('click', function () {
      var isOpen = mobileNav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      mobileNav.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
      document.body.classList.toggle('menu-open', isOpen);

      // Prevent body scroll when menu is open
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });

    // Close menu on escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mobileNav.classList.contains('is-open')) {
        mobileNav.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        mobileNav.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('menu-open');
        document.body.style.overflow = '';
        toggle.focus();
      }
    });
  }


  /* ---------- Cart Drawer ---------- */
  function initCartDrawer() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;

    var cartToggle = document.querySelector('[data-cart-toggle]');
    var cartClose = document.querySelector('[data-cart-close]');
    var cartOverlay = document.querySelector('[data-cart-overlay]');

    function openCart(e) {
      if (e) e.preventDefault();
      if (window.Penderyn && window.Penderyn.cart) window.Penderyn.cart.refresh();
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeCart() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    if (cartToggle) {
      cartToggle.addEventListener('click', openCart);
    }

    if (cartClose) {
      cartClose.addEventListener('click', closeCart);
    }

    if (cartOverlay) {
      cartOverlay.addEventListener('click', closeCart);
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeCart();
      }
    });
  }


  /* Age gate: handled inline by snippets/age-gate.liquid (no body scroll lock). */

  /* ---------- Announcement bar height ----------
     The bar is fixed and the header sits below it by --announcement-height. On a
     narrow screen the message wraps to two lines, so the assumed height left the bar
     covering the top of the header (and the basket icon). Measure it instead. */
  function syncAnnouncementHeight() {
    var bar = document.querySelector('.announcement-bar');
    if (!bar) return;
    var apply = function () {
      var h = Math.ceil(bar.getBoundingClientRect().height);
      if (h) document.documentElement.style.setProperty('--announcement-height', h + 'px');
    };
    apply();
    window.addEventListener('resize', apply, { passive: true });
    window.addEventListener('orientationchange', apply);
    if (window.ResizeObserver) new ResizeObserver(apply).observe(bar);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(apply).catch(function () {});
  }


  /* ---------- Hero video ----------
     Desktop only, and only after the page is interactive: the sources carry data-src so
     nothing downloads on a phone, on a slow connection, or for anyone who prefers
     reduced motion. The poster image is the hero until the video can actually play. */
  function initHeroVideo() {
    var video = document.querySelector('[data-hero-video]');
    if (!video) return;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var wideEnough = window.matchMedia('(min-width: 768px)').matches;
    var conn = navigator.connection || {};
    var frugal = conn.saveData === true || /2g/.test(conn.effectiveType || '');
    if (reduced || !wideEnough || frugal) return;

    var sources = video.querySelectorAll('source[data-src]');
    if (!sources.length) return;

    // Pick a rendition that suits the screen rather than always pulling 1080p.
    var want = (window.innerWidth * (window.devicePixelRatio || 1)) > 1400 ? 1080 : 720;
    var best = null;
    sources.forEach(function (s) {
      var h = parseInt(s.getAttribute('data-height'), 10) || 0;
      if (!best) { best = s; return; }
      var bh = parseInt(best.getAttribute('data-height'), 10) || 0;
      if (Math.abs(h - want) < Math.abs(bh - want)) best = s;
    });
    sources.forEach(function (s) { if (s !== best) s.remove(); });
    best.src = best.getAttribute('data-src');
    best.removeAttribute('data-src');

    video.addEventListener('playing', function () { video.classList.add('is-playing'); }, { once: true });
    video.preload = 'auto';
    video.load();
    var p = video.play();
    if (p && p.catch) p.catch(function () { /* autoplay blocked: the poster stays */ });
  }

  /* ---------- Cart state: one renderer for the drawer ----------
     Everything that changes the basket (add, +/-, remove) calls Penderyn.cart.refresh(),
     which reads /cart.js and redraws the drawer body, subtotal, footer and header count.
     Previously the drawer was server-rendered once, so quantity changes never reached
     Shopify and the footer was missing whenever the page loaded with an empty basket. */
  var Penderyn = window.Penderyn || (window.Penderyn = {});

  function formatMoney(cents) {
    var fmt = window.PENDERYN_MONEY_FORMAT || '£{{amount}}';
    var amount = (cents / 100).toFixed(2);
    var withCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g, withCommas)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100).toString())
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, Math.round(cents / 100).toString());
  }

  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function drawerItemHtml(item, index) {
    var variant = item.variant_title && item.variant_title !== 'Default Title'
      ? '<p class="cart-drawer__item-variant">' + esc(item.variant_title) + '</p>' : '';
    var image = item.image
      ? '<img src="' + esc(item.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2')) + '" alt="" width="60" height="60" loading="lazy">' : '';
    var wasPrice = item.original_line_price > item.final_line_price
      ? ' <s class="cart-drawer__item-was">' + formatMoney(item.original_line_price) + '</s>' : '';
    return '<div class="cart-drawer__item" data-line="' + index + '">'
      + '<a href="' + esc(item.url) + '" class="cart-drawer__item-image">' + image + '</a>'
      + '<div class="cart-drawer__item-details">'
      + '<a href="' + esc(item.url) + '" class="cart-drawer__item-title">' + esc(item.product_title) + '</a>'
      + variant
      + '<p class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + wasPrice + '</p>'
      + '<button type="button" class="cart-drawer__item-remove" data-cart-remove="' + index + '">Remove</button>'
      + '</div>'
      + '<div class="cart-drawer__item-qty">'
      + '<div class="qty-selector" data-qty-selector>'
      + '<button type="button" class="qty-selector__btn" data-cart-qty="' + index + '" data-delta="-1" aria-label="Decrease quantity">-</button>'
      + '<input type="number" class="qty-selector__input" value="' + item.quantity + '" min="0" data-cart-qty-input="' + index + '" aria-label="Quantity">'
      + '<button type="button" class="qty-selector__btn" data-cart-qty="' + index + '" data-delta="1" aria-label="Increase quantity">+</button>'
      + '</div></div></div>';
  }

  function renderCart(cart) {
    var body = document.querySelector('[data-cart-body]');
    var footer = document.querySelector('[data-cart-footer]');
    var count = document.querySelector('[data-cart-count]');
    var subtotal = document.querySelector('[data-cart-subtotal]');
    if (count) {
      count.textContent = cart.item_count;
      count.hidden = cart.item_count === 0;
    }
    if (body) {
      body.innerHTML = cart.item_count
        ? cart.items.map(function (item, i) { return drawerItemHtml(item, i + 1); }).join('')
        : '<p class="cart-drawer__empty">Your basket is empty</p>';
    }
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
    if (footer) footer.hidden = cart.item_count === 0;
    // Nothing in the basket is being posted when every line is a tour booking,
    // so do not promise to calculate shipping.
    var disclaimer = document.querySelector('[data-cart-disclaimer]');
    if (disclaimer) {
      disclaimer.textContent = cart.requires_shipping
        ? 'Taxes and shipping calculated at checkout'
        : 'Taxes calculated at checkout';
    }
    renderDrawerGift(cart);
  }

  /* Can anything in this basket be given to someone? Same rule as the basket page:
     anything that is not a tour booking, including a digital voucher, which is never
     posted but is almost always a gift. Shipping is the wrong test. */
  function cartIsGiftable(cart) {
    return (cart.items || []).some(function (i) { return i.product_type !== 'Booking'; });
  }

  function renderDrawerGift(cart) {
    var wrap = document.querySelector('[data-cart-gift]');
    if (!wrap) return;
    var giftable = cart.item_count > 0 && cartIsGiftable(cart);
    wrap.hidden = !giftable;
    if (!giftable) return;

    var input = wrap.querySelector('[data-cart-gift-input]');
    var panel = wrap.querySelector('[data-cart-gift-panel]');
    var toggle = wrap.querySelector('[data-cart-gift-toggle]');
    var existing = (cart.attributes && cart.attributes.gift_message) || '';
    // Do not stamp on what somebody is in the middle of typing.
    if (input && document.activeElement !== input) input.value = existing;
    if (existing && panel && panel.hidden) {
      panel.hidden = false;
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
    }
    if (input) {
      input.placeholder = cart.requires_shipping
        ? 'Printed on a card and packed with the order'
        : 'Included with the gift when it is sent';
    }
  }

  function initDrawerGift() {
    var wrap = document.querySelector('[data-cart-gift]');
    if (!wrap) return;
    var toggle = wrap.querySelector('[data-cart-gift-toggle]');
    var panel = wrap.querySelector('[data-cart-gift-panel]');
    var input = wrap.querySelector('[data-cart-gift-input]');
    var saved = wrap.querySelector('[data-cart-gift-saved]');

    if (toggle && panel) {
      toggle.addEventListener('click', function () {
        panel.hidden = !panel.hidden;
        toggle.setAttribute('aria-expanded', String(!panel.hidden));
        if (!panel.hidden && input) input.focus();
      });
    }

    /* Saved as it is typed, debounced, because the Checkout button sits right
       underneath it: a message that only saved on submit would be lost by the
       very click it was written for. */
    if (input) {
      var timer = null;
      var save = function () {
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { gift_message: input.value } }),
        })
          .then(function (r) { return r.json(); })
          .then(function () { if (saved) { saved.hidden = false; } })
          .catch(function () {});
      };
      input.addEventListener('input', function () {
        if (saved) saved.hidden = true;
        clearTimeout(timer);
        timer = setTimeout(save, 600);
      });
      // Leaving the field, or heading for checkout, must not race the debounce.
      input.addEventListener('blur', function () { clearTimeout(timer); save(); });
    }
  }

  Penderyn.cart = {
    refresh: function () {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { renderCart(cart); return cart; })
        .catch(function () {});
    },
    change: function (line, quantity) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity }),
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) { renderCart(cart); return cart; })
        .catch(function () {});
    },
  };

  /* Full basket page: changing a quantity applies straight away, so nobody edits a
     number and walks off thinking it saved. The Update button still works for anyone
     without JavaScript. */
  function initCartPageQuantities() {
    var form = document.querySelector('form[action="/cart"]');
    if (!form) return;
    form.addEventListener('change', function (e) {
      var input = e.target.closest('input[name="updates[]"]');
      if (!input) return;
      if (parseInt(input.value, 10) < 0 || input.value === '') input.value = 0;
      form.submit();
    });
  }

  /* Quantity and remove controls inside the drawer */
  function initDrawerQuantityControls() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;

    drawer.addEventListener('click', function (e) {
      var step = e.target.closest('[data-cart-qty]');
      if (step) {
        var line = parseInt(step.getAttribute('data-cart-qty'), 10);
        var input = drawer.querySelector('[data-cart-qty-input="' + line + '"]');
        var next = Math.max(0, (parseInt(input && input.value, 10) || 0) + parseInt(step.getAttribute('data-delta'), 10));
        Penderyn.cart.change(line, next);
        return;
      }
      var remove = e.target.closest('[data-cart-remove]');
      if (remove) {
        Penderyn.cart.change(parseInt(remove.getAttribute('data-cart-remove'), 10), 0);
      }
    });

    drawer.addEventListener('change', function (e) {
      var input = e.target.closest('[data-cart-qty-input]');
      if (!input) return;
      var line = parseInt(input.getAttribute('data-cart-qty-input'), 10);
      Penderyn.cart.change(line, Math.max(0, parseInt(input.value, 10) || 0));
    });
  }

  /* ---------- Ajax add to cart + "added" toast (stay on the page) ---------- */
  function initAjaxAddToCart() {
    var toast = document.getElementById('cart-toast');
    var count = document.querySelector('[data-cart-count]');
    var hideTimer;

    function showToast(item) {
      if (!toast) return;
      var img = toast.querySelector('[data-toast-image]');
      var title = toast.querySelector('[data-toast-title]');
      if (img) { if (item.image) { img.src = item.image; img.hidden = false; } else { img.hidden = true; } }
      if (title) title.textContent = item.product_title + (item.variant_title && item.variant_title !== 'Default Title' ? ' \u00b7 ' + item.variant_title : '');
      toast.hidden = false;
      requestAnimationFrame(function () { toast.classList.add('is-visible'); });
      clearTimeout(hideTimer);
      hideTimer = setTimeout(hideToast, 6000);
    }
    function hideToast() {
      if (!toast) return;
      toast.classList.remove('is-visible');
      setTimeout(function () { toast.hidden = true; }, 300);
    }
    if (toast) {
      var closeBtn = toast.querySelector('[data-toast-close]');
      if (closeBtn) closeBtn.addEventListener('click', hideToast);
    }

    function refreshCart() {
      return Penderyn.cart.refresh();
    }

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      var action = form.getAttribute('action') || '';
      if (action.indexOf('/cart/add') !== 0) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var originalText = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding\u2026'; }
      var fd = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to basket'); return j; }); })
        .then(function (item) { showToast(item); return refreshCart(); })
        .catch(function (err) {
          if (btn) btn.textContent = err.message || 'Could not add';
          setTimeout(function () { if (btn) btn.textContent = originalText; }, 2500);
        })
        .finally(function () { if (btn) { btn.disabled = false; if (btn.textContent === 'Adding\u2026') btn.textContent = originalText; } });
    });
  }

  /* ---------- Quantity Selectors ---------- */
  function initQuantitySelectors() {
    document.addEventListener('click', function (e) {
      var minusBtn = e.target.closest('[data-qty-minus]');
      var plusBtn = e.target.closest('[data-qty-plus]');

      if (minusBtn) {
        var input = minusBtn.parentElement.querySelector('[data-qty-input]');
        if (input) {
          var val = parseInt(input.value, 10) || 1;
          input.value = Math.max(0, val - 1);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      if (plusBtn) {
        var input = plusBtn.parentElement.querySelector('[data-qty-input]');
        if (input) {
          var val = parseInt(input.value, 10) || 0;
          input.value = val + 1;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  }


  /* ---------- Smooth Scroll ---------- */
  function initSmoothScroll() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href^="#"]');
      if (!link) return;

      var targetId = link.getAttribute('href');
      if (targetId === '#') return;

      var target = document.querySelector(targetId);
      if (!target) return;

      e.preventDefault();
      var headerOffset = parseInt(
        getComputedStyle(document.documentElement).getPropertyValue('--header-height'),
        10
      ) || 72;

      var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: top,
        behavior: 'smooth'
      });
    });
  }


  /* ---------- Product Image Gallery ---------- */
  function initProductGallery() {
    var thumbnails = document.querySelectorAll('.product-page__thumbnail');
    var mainImage = document.querySelector('.product-page__main-image');

    if (!thumbnails.length || !mainImage) return;

    thumbnails.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        // Update main image
        var fullSrc = thumb.getAttribute('data-full-src') || thumb.src;
        mainImage.src = fullSrc;

        // Update active state
        thumbnails.forEach(function (t) {
          t.classList.remove('is-active');
        });
        thumb.classList.add('is-active');
      });
    });
  }

})();
